module.exports = __webpack_public_path__ + "static/media/xls.bdcdc433.svg";